var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"text-sm pt-2"},[_vm._v("\n        "+_vm._s(_vm.$t('form.direct.message_vendeur'))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"shadow border border-gray-200 p-6 my-4 my-rounded bg-white"},[(_vm.data)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.data)}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e19b064","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/processes/cards/procedure/DirectCard.vue
// module id = null
// module chunks = 